<template>
  <div class="body">
    <v-app>
      <main-menu
        v-if="isLoggedIn"
        :show-menu-prop="menuShown"
        :currentTeamId="currentTeam.id"
        @signOut="signOut"
        @showMenuChanged="showMenuChanged($event)"
      />

        <v-app-bar app dark :color="primaryColor" v-if="isLoggedIn" clipped-left>
        <v-btn v-if="!menuShown" @click="menuClicked = true" text icon>
          <v-icon>menu</v-icon>
        </v-btn>
        <v-btn v-else @click="menuClicked = false" text icon>
          <v-icon>clear</v-icon>
        </v-btn>

        <v-btn text icon v-if="isDesktop"
          @click="handleBack"
          :disabled="isHome"
          key="back"
          data-test="back"
        >
          <v-icon>arrow_back</v-icon>
        </v-btn>

        <v-toolbar-title>{{ title }}</v-toolbar-title>

        <v-spacer></v-spacer>

        <!-- <v-btn icon @click="updateUsersHomePage()" :title="$t('app.set-homepage')"> -->
          <!-- <v-icon>home</v-icon> -->
        <!-- </v-btn> -->
        <v-btn icon @click="navigateToMap()" data-tutorial="2">
          <v-icon>map</v-icon>
        </v-btn>
        <v-btn icon @click="$router.push({name: 'visuals'})" v-if="$canm('vis')">
          <v-icon>transform</v-icon>
        </v-btn>
        <v-btn icon @click="$router.push({name: 'issues'})" v-if="$canm('mnt')">
          <v-icon>build</v-icon>
        </v-btn>
        <v-btn icon @click="$router.push({name: 'interventions'})" v-if="$canm('mnt')">
          <v-icon>history</v-icon>
        </v-btn>
        <v-btn icon @click="$refs.tutorial.start()" :disabled="!tutorial.available" :title="$t('tutorial.labels.help')">
          <v-icon>help</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- The key is needed to bypass caching entire pages that would prevent updating data when re-routing to the same page (component) -->
      <v-content>
        <router-view class="router-view" :key="$route.fullPath" ref="contentVM"
                     @tutorial-scenario="tutorial.scenario = $event"></router-view>
        <v-progress-circular indeterminate color="primary" class="ret-center-absolute" v-if="false"/>
      </v-content>

      <!-- Global dialogs and snackbars -->
      <destroy-dialog/>
      <unsaved-dialog/>
      <global-snackbar/>
      <tutorial :scenario="tutorial.scenario" @available="tutorial.available = $event" ref="tutorial"/>

    </v-app>
  </div>
</template>

<script>
import MainMenu from './main-menu.vue'
import DestroyDialog from './shared/dialogs/destroy-dialog.vue'
import UnsavedDialog from './shared/dialogs/unsaved-dialog.vue'// https://codesandbox.io/s/5x696p27rx
import GlobalSnackbar from './shared/global-snackbar.vue'
import Tutorial from './shared/tutorial.vue'
import UsersService from "@/services/users.service.es6";

export default {
  name: 'main-window',
  data () {
    return {
      menuClicked: this.isDesktop,
      tutorial: {
        scenario: 'default',
        available: false
      }
    }
  },
  computed: {
    title () {
      return this.$route.meta.title
    },
    primaryColor () {
      return this.$store.state.site.primaryColor ? this.$store.state.site.primaryColor : 'primary'
    },
    isHome () {
      return this.$route.name === 'home'
    },
    isLogin () {
      return this.$route.name === 'login'
    },
    isDesktop () {
      return this.$store.state.userAgent.isDesktop
    },
    isMobile () {
      return this.$store.state.userAgent.isMobile
    },
    currentTeam () {
      return this.$store.state.auth.currentTeam
    },
    teamMembers () {
      return this.$store.state.teamWorkers
    },
    isLoggedIn () {
      return this.$store.state.auth.currentUser != null && Object.keys(this.$store.state.auth.currentUser).length > 0
    },
    unauthorizedError () {
      return this.$store.state.errors.unauthorizedError
    },
    menuShown () {
      return this.menuClicked
    }
  },
  methods: {
    async updateUsersHomePage () {
      await this.$store.dispatch('updateItem', {
        modelName: 'users',
        item: { id: this.$store.state.auth.currentUser.id, homePage: this.$route.path }
      })

      UsersService.setHomePage(this.$route.path)
      this.$store.commit('showSnackbar', { message: this.$t('app.homepage-changed') })
    },
    signOut () {
      this.$cookies.remove('session')
      this.$store.commit('setCurrentUser', null)
      this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + ''
      console.log('signing out')
      this.$router.push({ name: 'login' })
    },
    // Routings
    editTeam () {
      this.$router.push({ name: `teams/id`, params: { id: this.currentTeam.id } })
    },
    navigateToMap() {
      const params = (this.$route.name === 'assets/id') ? { assetId: this.$route.params.id } : {}

      this.$router.push({ name: 'city-map', params })
    },
    showMenuChanged (event) {
      this.menuClicked = event
    },
    handleBack () {
      this.$router.go(-1)
    }
  },
  watch: {
    title () {
      return this.$route.meta.title
    },
    unauthorizedError (val) {
      console.log('[main-window][watch][unauthorizedError], val: ' + val)
      if (val === true) {
        this.signOut() // force logout
      }
    },
    $route (to, from) {
      this.tutorial.scenario = to.name
    }
  },
  mounted () {
    this.tutorial.scenario = this.$route.name
  },
  components: {
    MainMenu,
    DestroyDialog,
    UnsavedDialog,
    GlobalSnackbar,
    Tutorial
  }
}
</script>
